import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing24, spacing4 } from 'approot/shared/styles/spacing.style';
import { ColourItem } from 'approot/shared/colour/colour-token.style';
import { grey10, grey6 } from 'approot/shared/styles/colours.style';
import {
  FillInBlanksFieldCss,
  FillInBlanksFontSizeCss,
  FillInBlanksFontSizeProps,
  FillInBlanksLabelSupport,
  FillInBlanksPunctuationCss,
  FillInBlanksSentencesWrapper,
} from './fill-in-blanks-shared.style';

type FillInBlanksFieldProps = {
  $colours: ColourItem;
  $minWidth: number;
  $punctuation: string | null;
  $hasLabel: boolean;
  $fontSize: string | null;
  $fontFamily: string | null;
};

export const FillInBlanksPrintField = styled.div<FillInBlanksFieldProps>`
  display: inline-flex;
  max-width: ${({ $minWidth }) => rem($minWidth)};
  width: 100%;

  ${FillInBlanksFontSizeCss}
  ${FillInBlanksFieldCss}
  ${FillInBlanksPunctuationCss}
`;

type FillInBlanksAnswerProps = {
  $minWidth: number;
  $colours: ColourItem;
  $isFocused: boolean;
  $display: string;
  $label: string | null;
} & FillInBlanksFontSizeProps;
export const FillInBlanksPrintAnswer = styled.div<FillInBlanksAnswerProps>`
  padding: 0;
  position: relative;
  width: 100%;
  ${FillInBlanksLabelSupport}

  .tiptap {
    ${FillInBlanksFontSizeCss}
    outline: none;
    width: 100%;

    p {
      margin-bottom: 0;
    }
  }
`;

type FillInBlanksPrintTipTapWrapperProps = {
  $placeholder: string | null;
  $isScaffold: boolean;
} & FillInBlanksFontSizeProps;
export const FillInBlanksPrintTipTapWrapper = styled.div<FillInBlanksPrintTipTapWrapperProps>`
  ${FillInBlanksFontSizeCss}
  width: 100%;
  padding: 0;
  position: relative;
  overflow: hidden;

  p {
    margin: 0;

    ${({ $placeholder, $isScaffold }) =>
      $placeholder &&
      `
      &:after {
        color: ${$isScaffold ? grey10 : grey6};
        content: '${$placeholder}';
        position: absolute;
        top: 0;
        pointer-events: none;
        white-space: nowrap;
      }
    `}
  }
`;

export const FillInBlanksPrintTipTap = styled.div<FillInBlanksFontSizeProps>`
  ${FillInBlanksFontSizeCss}
  outline: none;
  width: 100%;
  padding: 0;
  position: relative;
`;

export const FillInBlanksPrint = styled(FillInBlanksSentencesWrapper)``;

export const FillInBlanksPrintSentence = styled.div`
  padding: ${rem(spacing4)} ${rem(spacing24)};
  position: relative;

  div:first-child {
    margin-left: 0;
  }
`;
